<template>
    <div class="app-main-content">
        <h1>
            Verification of Reservation
        </h1>
        <UserContact :verify="verify" @doContactValidated="setIndividualContact" @doResetVerify="resetVerify" :verifyDetails="description"
         :showNotification="false" ref="contactUser"/>

        <BaseButtonGroup>
            <button type="button" @click="router.push({ name: PAGES.findRes })">{{ language.btnPrev }}</button>
            <button type="button" class="app-btn-primary" @click.prevent="handleNextStep">{{ language.btnNext }}</button>
        </BaseButtonGroup>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import UserContact from '../user/UserContact.vue';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup.vue';
import appConfig from '@/app.config';
import { RESERVATION_FIND } from '@/store/_commons';
import { useHead } from '@unhead/vue';
import { usePhoneFormatter } from '@/composables/usePhoneFormatter';

// Metadata 
useHead({
  title: `Verify reservation | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'Look up an existing reservation by verifying one of your contact information'
    }
  ]
});

const { formatPhoneForRims } = usePhoneFormatter();

// Vuex Store and Router 
const store = useStore();
const router = useRouter();

// Template Refs 
const contactUser = ref(null);

// Emits 
const emit = defineEmits(['doResetVerify']);

//  Reactive State 
const verify = ref(false);
const myContact = ref(null);

// Data 
const description = `For security of your personal information the system will verify the contact information against the matching reservation.` +
                      `<ul style="list-style: auto; padding: 0 35px; margin: 10px 0"><li style="margin-bottom: 5px"> Choose the contact information to verify and click on 'Send verification code'.</li> <li>Enter the verification code and click on 'Next'.</li>
                      </ul>` +
                    `<b> NOTE: </b>Check your email Span / Junk folders.` +
                    `\n<p> If you don't receive text message for your code you may have chosen to opt out text messages from RI DMV. To re-enroll text START to ${window.config.REENROLLNUMBER}.</p>` ;


// Computed Properties 
const language = computed(() => store.state.user.LANG);
const PAGES = computed(() => store.state.user.PAGES);
const resLookup = computed(() => store.state.user.resLookup);

// Methods 
const handleNextStep = async () => {
  await contactUser.value.continueToNextStep();
  if (myContact.value != null) {
    let info = null;
    if (resLookup.value.appointmentNumber == '') {
      info = {
        appointmentNumber: '',
        emailAddress: myContact.value.email,
        phoneNumber: formatPhoneForRims(myContact.value.phone)
      };
    } else {
      info = {
        appointmentNumber: resLookup.value.appointmentNumber || '',
        emailAddress: '',
        phoneNumber: ''
      };
    }
    const reservationsFound = await store.dispatch(RESERVATION_FIND, info);

    if (reservationsFound.length > 0) {
      store.commit('user/setReservationsFound', reservationsFound);
      router.push({ name: PAGES.value.updateRes }).catch(() => {});
    }
  }
};

const resetVerify = () => {
  emit('doResetVerify');
};

const setIndividualContact = (data) => {
  myContact.value = data;
};
</script>


<style scoped lang="scss">
.user-contact {
  .app-contact-info-text{
    max-width: fit-content;
  }
}

.app-button-group {
  button {
    margin-bottom: 1.125em;
    &:not(:last-child) {
      margin-right: 1em;
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }
  }
}

</style>